import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToImprovementPlanType = mapDictionaryState;

const improvementPlanTypeApi = createDictionaryApiFactory("improvementPlanType");

export const getImprovementPlanType = improvementPlanTypeApi.search;
